/**
 * Display-only numeric formatting (HUD / tooltips / combat floats).
 * Truncates toward zero (절삭). Positive → floor. Never use in combat math.
 */

/** Truncate toward zero; `decimals` caps fractional digits (default integer). */
export function truncDisplay(n: number, decimals = 0): number {
  if (!Number.isFinite(n)) return 0;
  if (decimals <= 0) return Math.trunc(n);
  const places = Math.min(8, Math.floor(decimals));
  const f = 10 ** places;
  return Math.trunc(n * f) / f;
}

/** Integer string via trunc toward zero. */
export function formatInt(n: number): string {
  return String(truncDisplay(n, 0));
}

/**
 * String with at most `decimals` places after trunc.
 * Trailing zeros after the decimal point are stripped.
 */
export function formatDisplay(n: number, decimals = 0): string {
  const t = truncDisplay(n, decimals);
  if (decimals <= 0 || Number.isInteger(t)) return String(Math.trunc(t));
  return t.toFixed(decimals).replace(/\.?0+$/, "");
}

const COMBAT_FLOAT_KEYS = new Set(["damage", "amount", "value"]);

/** Format a float-text template var; combat amounts → integer trunc. */
export function formatFloatVar(key: string, v: string | number): string {
  if (typeof v !== "number" || !Number.isFinite(v)) return String(v);
  if (COMBAT_FLOAT_KEYS.has(key)) return formatInt(v);
  return formatDisplay(v, 1);
}
